import firebase from 'firebase/app';
import 'firebase/auth';

export default async function getAuthToken(): Promise<string> {
  const user = firebase.auth().currentUser;
  if (!user) {
    throw new Error('Not signed in');
  }
  return user.getIdToken();
}
